import React, { useId } from "react";

/* ---------- Utility: Generate Safe ID ---------- */

const generateSafeId = (id, name, alt, text, ariaLabel, reactId) => {
  if (id) return id;

  const source = name || alt || text || ariaLabel || reactId;

  return source
    ?.toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-_]/g, "");
};
// return <button id={generatedId} onClick={onClick} {...props}>{label}</button>;

/* ---------- Custom Button ---------- */

const CustomButton = ({
  id,
  name,
  alt,
  onClick,
  text = "Click Me",
  icon,
  iconPosition = "right",
  backgroundColor = "#ffaf32",
  color = "#000",
  fontSize = "16px",
  style = {},
  ...props
}) => {
  const reactId = useId();

  const generatedId = generateSafeId(
    id,
    name,
    alt,
    text,
    props["aria-label"],
    reactId
  );

  return (
    <button
      id={generatedId}
      data-testid={generatedId}
      onClick={onClick}
      style={{
        backgroundColor: backgroundColor,
        boxShadow: "none",
        outline: "none",
        width: "auto",
        height: "42px",
        padding: "8px 12px",
        fontSize: fontSize,
        border: "none",
        borderRadius: "10px",
        color: color,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: iconPosition === "left" ? "flex-start" : "center",
        ...style,
      }}
      {...props}
    >
      {icon && iconPosition === "left" && (
        <img
          src={icon}
          alt="icon"
          style={{ width: "20px", height: "20px", marginRight: "8px" }}
        />
      )}

      {text}

      {icon && iconPosition === "right" && (
        <img
          src={icon}
          alt="icon"
          style={{ width: "20px", height: "20px", marginLeft: "8px" }}
        />
      )}
    </button>
  );
};

/* ---------- Regular Button ---------- */

const RegularButton = ({
  id,
  name,
  alt,
  onClick,
  text = "Click Me",
  border = ".2px solid #000",
  backgroundColor = "#282e26",
  color = "white",
  width = "140px",
  height = "38px",
  fontWeight = "bold",
  borderRadius = "50px",
  style = {},
  ...props
}) => {
  const reactId = useId();

  const generatedId = generateSafeId(
    id,
    name,
    alt,
    text,
    props["aria-label"],
    reactId
  );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginRight: "10px",
      }}
    >
      <button
        id={generatedId}
        data-testid={generatedId}
        style={{
          color: color,
          backgroundColor: backgroundColor,
          borderRadius: borderRadius,
          width: width,
          height: height,
          fontWeight: fontWeight,
          border: border,
          cursor: "pointer",
          ...style,
        }}
        onClick={onClick}
        type="button"
        {...props}
      >
        {text}
      </button>
    </div>
  );
};

export { CustomButton, RegularButton };